export const GET_SITESURVEYS = "GET_SITESURVEYS"
export const GET_SITESURVEYS_SUCCESS = "GET_SITESURVEYS_SUCCESS"
export const GET_SITESURVEYS_FAIL = "GET_SITESURVEYS_FAIL"

export const ADD_SITESURVEY = "ADD_SITESURVEY"
export const ADD_SITESURVEY_SUCCESS = "ADD_SITESURVEY_SUCCESS"
export const ADD_SITESURVEY_FAIL = "ADD_SITESURVEY_FAIL"

export const UPDATE_SITESURVEY = "UPDATE_SITESURVEY"
export const UPDATE_SITESURVEY_SUCCESS = "UPDATE_SITESURVEY_SUCCESS"
export const UPDATE_SITESURVEY_FAIL = "UPDATE_SITESURVEY_FAIL"

export const DELETE_SITESURVEY = "DELETE_SITESURVEY"
export const DELETE_SITESURVEY_SUCCESS = "DELETE_SITESURVEY_SUCCESS"
export const DELETE_SITESURVEY_FAIL = "DELETE_SITESURVEY_FAIL"

export const SET_SITESURVEY_FIELD_ERRORS = "SET_SITESURVEY_FIELD_ERRORS"